function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { AuthenticationTypes } from '@shared/services/http/httpProtocol';
import { Constants } from '@shared/utils/constants';
import { logger } from '@src/logger';
import { logError } from '@shared/utils/httpClientUtil';
import * as httpProtocol from './httpProtocol';
const commerceHttpOptions = {
    requireCorrelationId: true,
    stringifyPostData: false,
    allowOrigin: true,
    authenticationType: AuthenticationTypes.CommerceApi,
    setBearerHeader: true,
    returnRawResponse: true
};
/**
 * PreWarm an account
 * @param Object containing named parameters for the call
 * @returns Promise with the response, containing a list of comments for the given review
 */ export function preWarmAccount(_0) {
    return _async_to_generator(function*({ addTestHeader, commerceApiHost }) {
        try {
            const endpoint = `${commerceApiHost}/v1/my-org/purchaseService.PreloadData`;
            const post = httpProtocol.post(endpoint, commerceHttpOptions);
            const headers = addTestHeader ? {
                'x-ms-test': 'test'
            } : {};
            post.addHeader(headers);
            return yield post.request();
        } catch (error) {
            logError('preWarmingCommerceAPIAJAX', error);
            logger.error('preWarmingCommerceAPIAJAX', {
                action: Constants.Telemetry.Action.PreWarmAJAX,
                actionModifier: Constants.Telemetry.ActionModifier.Error,
                error
            });
            return Promise.resolve(error);
        }
    }).apply(this, arguments);
}
